import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { SIZES, FONTS, COLORS } from '../constants'

import { MaterialIcons } from '@expo/vector-icons';


export default function OutlineBtn({ text, iconName, iconSize, iconColor, onPress, disabled }) {

  return (
    <>
      <TouchableOpacity
        style={styles.container}
        onPress={ () => {
          disabled ? alert("Uzupełnij profil") : onPress() }
        }
      >
        <View style={styles.outlineBtn}>
          {/* <MaterialIcons name="arrow-forward" size={48} color={COLORS.primary} /> */}
          {/* <AntDesign name={iconName} size={24} color="black" /> */}
          <MaterialIcons name={iconName} size={iconSize} color={iconColor} />

          <Text style={disabled ? [styles.rightText, {opacity: 0.2}] : styles.rightText}>
            {text}
          </Text>
        </View>
      </TouchableOpacity>
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: 15,
    // marginTop: 5,
  },
  outlineBtn: {
    backgroundColor: COLORS.background,
    borderColor: COLORS.primary,
    borderRadius: 15,
    borderWidth: 1,
    alignItems: 'center',
    alignSelf: 'stretch',
    justifyContent: 'center',
    flexDirection:'row', 
    flexWrap:'wrap',
    width: 300,
    height: 60,
  },
  rightText: {
    color: COLORS.primary,
    fontSize: 16,
    paddingHorizontal: 10
  }
})